import * as ApiKey from './api-key'
import * as AppAction from './app-action'
import * as AppActionCall from './app-action-call'
import * as AppBundle from './app-bundle'
import * as AppDefinition from './app-definition'
import * as AppDetails from './app-details'
import * as AppInstallation from './app-installation'
import * as AppSignedRequest from './app-signed-request'
import * as AppSigningSecret from './app-signing-secret'
import * as AppUpload from './app-upload'
import * as Asset from './asset'
import * as AssetKey from './asset-key'
import * as BulkAction from './bulk-action'
import * as Comment from './comment'
import * as ContentType from './content-type'
import * as EditorInterface from './editor-interface'
import * as Entry from './entry'
import * as Environment from './environment'
import * as EnvironmentAlias from './environment-alias'
import * as EnvironmentTemplate from './environment-template'
import * as EnvironmentTemplateInstallation from './environment-template-installation'
import * as Extension from './extension'
import * as Http from './http'
import * as Locale from './locale'
import * as Organization from './organization'
import * as OrganizationInvitation from './organization-invitation'
import * as OrganizationMembership from './organization-membership'
import * as PersonalAccessToken from './personal-access-token'
import * as AccessToken from './access-token'
import * as PreviewApiKey from './preview-api-key'
import * as Release from './release'
import * as ReleaseAction from './release-action'
import * as Role from './role'
import * as ScheduledAction from './scheduled-action'
import * as Snapshot from './snapshot'
import * as Space from './space'
import * as SpaceMember from './space-member'
import * as SpaceMembership from './space-membership'
import * as Tag from './tag'
import * as Task from './task'
import * as Team from './team'
import * as TeamMembership from './team-membership'
import * as TeamSpaceMembership from './team-space-membership'
import * as UIConfig from './ui-config'
import * as Upload from './upload'
import * as Usage from './usage'
import * as User from './user'
import * as UserUIConfig from './user-ui-config'
import * as Webhook from './webhook'
import * as Workflow from './workflow'
import * as WorkflowDefinition from './workflow-definition'
import * as WorkflowsChangelog from './workflows-changelog'

export default {
  ApiKey,
  AppAction,
  AppActionCall,
  AppBundle,
  AppDefinition,
  AppInstallation,
  AppUpload,
  AppSignedRequest,
  AppSigningSecret,
  AppDetails,
  Asset,
  AssetKey,
  BulkAction,
  Comment,
  ContentType,
  EditorInterface,
  Entry,
  Environment,
  EnvironmentAlias,
  EnvironmentTemplate,
  EnvironmentTemplateInstallation,
  Extension,
  Http,
  Locale,
  Organization,
  OrganizationInvitation,
  OrganizationMembership,
  PersonalAccessToken,
  AccessToken,
  PreviewApiKey,
  Release,
  ReleaseAction,
  Role,
  ScheduledAction,
  Snapshot,
  Space,
  SpaceMember,
  SpaceMembership,
  Tag,
  Task,
  Team,
  TeamMembership,
  TeamSpaceMembership,
  UIConfig,
  Upload,
  Usage,
  User,
  UserUIConfig,
  Webhook,
  WorkflowDefinition,
  Workflow,
  WorkflowsChangelog,
}
